import {AmplitudeEvent} from '@udemy-v2/amplitude';

type TeamPlanLeadFormProperties = {
    formId: string;
};

/**
 * Shared base for all Team Plan lead-form Amplitude events.
 * Subclasses only need to supply the `eventName`; properties default to `{ formId }`.
 */
export class TeamPlanLeadFormEvent extends AmplitudeEvent {
    protected readonly formId: string;

    constructor(eventName: string, formId: string) {
        super();
        this.eventName = eventName;
        this.category = 'lead_generation';
        this.formId = formId;
    }

    toEventProperties(): TeamPlanLeadFormProperties {
        return {formId: this.formId};
    }
}
